export default __webpack_public_path__ + "static/Blind-angels-jose-joaquin-video-5eb741bddd7ff082964a5808a86a41ef.png";